import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { concatStrings } from '../../../utils/string'
import { RouteDelimiter } from '../../global'
import { RoutesComponentsMapper } from '../../Routes'

function Router () {
  return (
    <Routes>
      {RoutesComponentsMapper.map((Element, index) => (
        <React.Fragment key={index}>
          <Route
            path={concatStrings(RouteDelimiter, [Element.route])}
            element={<Element.component />}
          />
        </React.Fragment>
      ))}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default Router
